import { useState } from 'react'
import { sendLoginPayload } from 'account-portal-library/lib/emailSignIn';
import { validateSessionToken} from "account-portal-library/lib/helperFunctions";
import { getGotoUrlFromCookies } from '../../gotoUrl.js';
import AppVars from './../../AppVars';
import Logger from '../../Logger.js';

import Image from 'react-bootstrap/Image';
import Button from 'react-bootstrap/Button';

import Logo from '../../static/images/Toyota-Logo.svg';
import LoadingGif from '../../static/images/loading.gif';
import navigateWithAnalytics from '../../analytics/navigateWithAnalytics.js';

const ACCOUNT_LOCKED_URL = "/accountlocked";
const UNKNOWN_ERROR_URL = "/unknownerror";

const appVars = AppVars.getInstance();
const logger = Logger.getInstance();

const MfaTrustPage = ({ style = 'TO', payload, savePayload }) => {
    const [loading, setLoading] = useState(false);

    const addTrustDevice = async (action) => {
        try {
            const url = appVars.getBaseUrl() + "/" + appVars.getName() + '/json' + appVars.getRealm() + '/authenticate';
            const headers = {
                'Accept-API-Version': 'resource=2.1',
                'Content-Type': 'application/json'
            }
            const params = {
                'authIndexType': 'service',
                'authIndexValue': appVars.getMFATree()
            }
            const trustPayload = payload;
            if (trustPayload?.callbacks) {
                trustPayload.callbacks[0].input[0].value = action;
            }
            const choiceResponse = await sendLoginPayload(trustPayload, url, headers, params);
            if (choiceResponse.status !== 200) {
                throw choiceResponse.response;
            }
            savePayload(choiceResponse.response)
            handleSuccess(choiceResponse.response)
        } catch (errorResponse) {
            // console.log("Error -> ", errorResponse);
            handleFailure(errorResponse);
        }
    }

    const checkToken = async (journeyResponse) => {
        try {
            const tokenId = journeyResponse.tokenId
            if (tokenId != null) {
                const validateResponse = await validateSessionToken(tokenId, appVars.getBaseUrl(), appVars.getName(), appVars.getRealm());
                return validateResponse.response.valid;
            } else {
                return false;
            }
        }
        catch {
            return false;
        }
    }

    const handleSuccess = async (journeyResponse) => {
        if (journeyResponse.callbacks == null) {
            const tokenValid = await checkToken(journeyResponse);
            setLoading(false)
            if (tokenValid) {
                const gotoUrl = getGotoUrlFromCookies(['T']);                   
                navigateWithAnalytics(gotoUrl, "cookie-redirect", "auto");
            } else {
                navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
            }
        } else {
            setLoading(false)
        }
    }

    const handleFailure = (journeyResponse) => {
        const failureUrl = journeyResponse.failureUrl
        //If invalid credentials
        if (failureUrl === ACCOUNT_LOCKED_URL) {
            setLoading(false)
        }
        else {
            setLoading(false)
            navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
        }
    }

    const onSkip = () => {
        setLoading(true)
        addTrustDevice(1)
    }

    const onAdd = () => {
        setLoading(true)
        addTrustDevice(0)
    }

    return <div className="login-wrapper" >
        <div className="relative login-box">
            <img src={Logo} className="login-logo__TO absolute" alt="Toyota"></img>
            <div className="title__TO left">Add trusted device</div>
            <div className="sign-in-mfa-grid">
                <div className="message__TO left">Click an option below to add this device to your trusted devices. This will save extra verification steps when you make edits on this device in the future.</div>
            </div>
            <div className='mfa-button-group login-item-height'>
                <div className="username-button-grid">
                    <Button bsPrefix="login-button__TO button-duration" type="submit" onClick={onAdd}>Add Device</Button>
                    <Button bsPrefix="login-button-outline__TO" type="submit" onClick={onSkip}>Skip</Button>
                </div>
            </div>
        </div>
        <Image data-testid="loadingGIF" className={`working ${loading ? "" : "none"}`} id="loadingGIF" src={LoadingGif} aria-hidden="true" />
    </div>
}

export default MfaTrustPage;